import React from 'react';
import Input from "../../../PopUp/Input";
import BaseField from '../BaseField/BaseField';

type IntegerFieldProps = {
  id?: string;
  title?: string;
  label?: string;
  displayName?: string;
  showTitle?: boolean;
  value?: string;
  placeholder?: string;
  onChangeValue?: (value: string) => void;
  disabled?: boolean;
  isSelected?: boolean;
}

const IntegerField = ({ id = 'integer-field-input', title = 'Title', label = 'Integer Field', displayName, showTitle = true, value = '', placeholder = '', onChangeValue = () => {}, disabled = false, isSelected = false }: IntegerFieldProps) => {
  const baseId = id || 'integer-field';

  const handleChange = (value: string) => {
    if (/^-?\d*$/.test(value) || value === '') {
      onChangeValue(value);
    }
  };

  const displayLabel = showTitle && displayName ? displayName : (showTitle ? label : '');

  return (
    <BaseField
      id={baseId}
      label={displayLabel}
      isSelected={isSelected}
      showTitle={showTitle}
    >
      <Input
        id={`${baseId}-input`}
        className="tw-w-full"
        placeholder={placeholder}
        value={value}
        onChangeValue={handleChange}
      />
    </BaseField>
  );
};

export default IntegerField;